// extracted by mini-css-extract-plugin
export default {"list02":"index_list02_-yeCj","t0":"index_t0_-sHOB","textBg":"index_textBg_uHzpL","lbn":"index_lbn_prEa6"};